import React from 'react';
//import MEDIUM_ICON from '../../images/icons/medium.svg';
import LINKEDIN_ICON from '../../images/icons/linkedin.svg';
import TWITTER_ICON from '../../images/icons/twitter.svg';
import FB_ICON from '../../images/icons/facebook.svg';
import INSTAGRAM_ICON from '../../images/icons/instagram.svg'
import './Footer.scss';




const Footer = props => {
 // const { links } = props;
  return (
    <div className="footer-wrapper">
      <div className="icons-wrapper">
     
        <a
          className="social-link"
          href="https://www.linkedin.com/company/sixt-research-development-india"
          target="_blank"
          rel="noopener noreferrer" 
        >
          <img src={LINKEDIN_ICON} alt="linkedin link" />
        </a>
        <a className="social-link" href="https://www.instagram.com/sixtindialife/" target="_blank" rel="noopener noreferrer" >
          <img src={INSTAGRAM_ICON} alt="instagram link" />
        </a>
        <a className="social-link" href="https://www.facebook.com/SixtIndiaLife" target="_blank" rel="noopener noreferrer" >
          <img src={FB_ICON} alt="fb link" />
        </a>
        <a className="social-link" href="https://twitter.com/SixtIndiaLife" target="_blank" rel="noopener noreferrer" >
          <img src={TWITTER_ICON} alt="twitter link" />
        </a>
      </div>

      <div className="links-wrapper">
        
          <span className="link">
            <a href="https://about.sixt.com/websites/sixt_cc/English/8100/privacy-policy.html">Privacy Policy</a>
          </span>
          <span className="link">
            <a href="https://www.sixt.jobs/en" >SIXT JOBS</a>
          </span>
          <span className="link">
            <a href="https://medium.com/the-sixt-india-blog">Blogs</a>
          </span>
          <span className="link">
            <a href="/contact-us" >Contact Us</a>
          </span>
          
     
       
      </div>
    
    </div>
  );
};

export default Footer;
